<template>
    <div class="index page-wrapper" :class="{ 'index-top-tab': storeCommon.inTopTab }">
        <QmHeader ref="refQmHeader"></QmHeader>
        <FixedRight></FixedRight>
        <PersonArea @refresh="getIndexData" ref="refPersonArea"></PersonArea>
        <TaskModule v-if="store.indexData.task" @share="onShowShare" @refresh="getIndexData" ref="refTaskModule"></TaskModule>
        <AnswerModule ref="refAnswerModule" @loadResource="loadMagicWeaponSvga"></AnswerModule>
        <CommunityModule></CommunityModule>
        <QPop v-model="showEmpty.show" position="bottom" :zIndex="199" class="g-pop-noanimate g-pop-nobg" :contentIsScroll="false" :closeIconTypes="[]">
            <div class="activity-end" :style="{ paddingTop: storeCommon.inTopTabNavHeight + storeCommon.headerHeight + 'px' }">
                <QEmpty :type="showEmpty.type" :tip="showEmpty.tip" :btnText="showEmpty.btnText" @click="getIndexData"></QEmpty>
            </div>
        </QPop>

        <QShare v-model="showShare" :showNativeShareTab="storeCommon.inTopTab" :typeList="shareTypeList" :shareInfo="shareConfig" :statusBarHeight="storeCommon.statusBarHeight" @share="onShareSuccess"></QShare>
        <QOpenApp class="share-full-page" v-if="!storeCommon.systemInfo.inQmApp" :params="openAppParams">
            <div></div>
        </QOpenApp>
        <!-- 答对获得弹窗 -->
        <QPop systemBackName="get" class="g-pop-w-full g-pop-nobg g-pop-dark-overlay" v-model="store.popStatus.get" :contentIsScroll="false">
            <PopGet></PopGet>
        </QPop>
        <!-- 答错未获得弹窗 -->
        <QPop systemBackName="noget" class="g-pop-w-full g-pop-nobg g-pop-dark-overlay" v-model="store.popStatus.noget" :contentIsScroll="false">
            <PopNoget></PopNoget>
        </QPop>
        <!-- 查看法宝弹窗 -->
        <QPop systemBackName="view" class="g-pop-w-full g-pop-nobg g-pop-dark-overlay" v-model="store.popStatus.view" :contentIsScroll="false">
            <PopView @refresh="getIndexData"></PopView>
        </QPop>
        <!-- 查看奖品弹窗 -->
        <QPop systemBackName="viewAward" class="g-pop-w-full g-pop-nobg g-pop-dark-overlay" v-model="store.popStatus.viewAward" :contentIsScroll="false">
            <PopViewAward></PopViewAward>
        </QPop>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useStoreCommon } from '@common/store/common';
import { usePageBaseInit } from '@common/hooks';
import { QShare, QPop, QEmpty } from '@q-front-npm/h5-ui';
import QmHeader from '@common/components/qm-header/index.vue';
import FixedRight from './components/fixed-right/index.vue';
import PersonArea from './components/person-area/index.vue';
import TaskModule from './components/task-module/index.vue';
import AnswerModule from './components/answer-module/index.vue';
import CommunityModule from './components/community-module/index.vue';
import PopGet from './components/pop-get/index.vue';
import PopNoget from './components/pop-noget/index.vue';
import PopView from './components/pop-view/index.vue';
import PopViewAward from './components/pop-view-award/index.vue';
import { useStore } from './store';
import { addNABackToWebviewEvent, closeWebview, onInterceptKeyBack, jsbReportV3 } from '@q-front-npm/jsbridge';
import { apiIndex } from './http/api';
import { shareConfig, shareTypeList } from '@common/assets/ts/const';
import { useStorePreload } from './store/preload';
import { magicWeaponResourceList } from './store/preload-resource';
import QOpenApp from '@common/components/q-open-app/index.vue';
import '@q-front-npm/h5-ui/lib/q-btn/style/freereader.css';
import { sleep } from 'radash';
usePageBaseInit();

const storeCommon = useStoreCommon();
const store = useStore();
const storePreload = useStorePreload();
const showEmpty = ref({
    show: false,
    type: 'activityEnd',
    tip: '活动已结束',
    btnText: '',
});
const getIndexData = async() => {
    try {
        showEmpty.value.show = false;
        const res = await apiIndex({ category: storeCommon.systemInfo.inQmApp ? '' : 'share', });
        const { user_info, spiritual_power_value, level, magic_weapon, current_time, } = res;
        const { read_time, user_type, } = user_info;
        const { user_current_value, level_value, } = spiritual_power_value;
        const readPercent = Math.floor((read_time / 60) * 100);
        res.user_info.readPercent = readPercent > 100 ? 100 : readPercent;
        res.isLogin = ['1', '2'].includes(user_type);
        res.isBlankUser = user_type === '0';
        res.isMaxLevel = level.num === '7';
        res.canUpgrade = +user_current_value >= +level_value;
        res.showCommunity2 = current_time >= 1759507200; // 10-04
        store.setIndexData(res);
        store.setMagicWeapon(magic_weapon);
        if (!res.isMaxLevel) {
            loadUpgradeSvga();
        }
        loadMagicWeaponSvga();
    } catch (err: any) {
        console.log('-- getIndexData error', err);
        const { code, details, } = err?.data?.errors || { details: '网络异常，请重试', };
        const isEnd = code === '34010103';
        showEmpty.value = {
            show: true,
            type: err.isNetworkError ? 'network' : isEnd ? 'activityEnd' : 'error',
            tip: err.isNetworkError ? '无法连接到网络，请检查网络连接后重试' : isEnd ? '活动已结束' : details,
            btnText: isEnd ? '' : '点击重试',
        };
    }
};

const refQmHeader = ref();
if (storeCommon.systemInfo.isHarmony && storeCommon.systemInfo.inQmApp) {
    showEmpty.value = {
        show: true,
        type: 'error',
        tip: '活动功能正在开发中，敬请期待',
        btnText: '',
    };
} else {
    getIndexData();
}

const showShare = ref(false);
const onShowShare = () => {
    showShare.value = true;
};
const refTaskModule = ref();
const onShareSuccess = () => {
    console.log('-- onShareSuccess');
    showShare.value = false;
    refTaskModule.value?.onShareSuccess();
};

const refPersonArea = ref();
const updateUpgradeBtnStatus = () => {
    if (!refPersonArea.value) {
        setTimeout(() => {
            updateUpgradeBtnStatus();
        }, 60);
        return;
    }
    refPersonArea.value.update();
};
// 加载升级动画
const loadUpgradeSvga = () => {
    updateUpgradeBtnStatus();
    if (store.svgaFiles.upgrade) {
        return;
    }
    const preloadIns = storePreload.initPreloadResource();
    if (!preloadIns) {
        return;
    }
    preloadIns.onComplete = () => {
        initUpgradeSvga();
    };
};
// 延迟加载法宝动画
const loadMagicWeaponSvga = async() => {
    if (store.svgaFiles['magic-weapon']) {
        return;
    }
    const { user_fragment_num, need_fragment_num, } = store.magicWeapon;
    const canMergeMagicWeapon = +user_fragment_num >= +need_fragment_num;
    if (!canMergeMagicWeapon) {
        return;
    }
    // 延迟加载法宝动画
    await sleep(1500);
    if (storePreload.preloadIns.preloadSvga) {
        const res = await storePreload.preloadIns.preloadSvga(magicWeaponResourceList[0]);
        store.setSvgaFiles('magic-weapon', res);
    } else {
        storePreload.initPreloadResource([magicWeaponResourceList[0]]);
    }

    await sleep(1500);
    console.log(store.svgaFiles['magic-weapon']);
};

const initUpgradeSvga = () => {
    if (!refPersonArea.value) {
        setTimeout(() => {
            initUpgradeSvga();
        }, 60);
        return;
    }
    refPersonArea.value.initSvga();
};

const saPageView = () => {
    jsbReportV3('moon_full_#_view', { page_name: 'moon', });
};
saPageView();
const url = `https://xiaoshuo.wtzw.com/h5/activity/freereaderMidAutumn/index?full_screen=3`;
const openAppParams = {
    url,
};

(window as any).onListenSystemBack = onInterceptKeyBack;
(window as any).onSystemBackCb = (type: string) => {
    if (type === 'no-show-pop') {
        closeWebview();
    }
};

const refAnswerModule = ref();
if (storeCommon.inTopTab) {
    (window as any).book_mall_activity_appear = (status: string | number) => {
        console.log('-- book_mall_activity_appear', status);
        if (status === 1 || status === '1') {
            getIndexData();
            refAnswerModule.value?.refresh();
        }
    };
} else {
    addNABackToWebviewEvent((type: string) => {
        if (type === 'resume') {
            getIndexData();
            refAnswerModule.value?.refresh();
        }
    });
}
</script>
<style lang="scss">
@import '@/assets/styles/sprites.scss';
@import '@/assets/styles/sprites2.scss';
@import '@/assets/styles/iconfont.scss';

.index {
    @include sprites-index($index-sprites);
    @include sprites-index2($index2-sprites);
    background-color: #103673;
    position: relative;
    margin-top: -100px;
    font-family: 'Source Han Serif SC', 'Noto Serif SC', '思源宋体', 'SimSun', serif;
    overflow-x: hidden;
    &-top-tab {
        min-height: 0;
        margin-top: 0;
    }
}
.g-pop-noanimate {
    --q-popup-duration: 0s;

    .q-popup-content {
        max-height: unset !important;
    }
}
.pop-bg {
    width: 600px;
    height: 672px;
    background: url('@/assets/images/pop-bg.png') no-repeat center/100% 100%;
}
</style>
<style lang="scss" scoped>
.activity-end {
    height: 100vh;
    background: linear-gradient(180deg, #06327a 0%, #4d63b9 100%);

    :deep(.q-empty-tip) {
        color: #fff;
    }
}

.share-full-page {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
}
</style>
